import type { SubscriptionFeatures } from "../types";

export type ExportFeatureKey = "bulk" | "premium" | "csv" | "html" | "json" | "pdf" | "redaction" | "vtt" | "word";

// Formats that premium plan unlocks
// "redaction" and "bulk" are NOT overridden by premium -- they are standalone gates.
const PREMIUM_OVERRIDES: ExportFeatureKey[] = ["word", "pdf", "vtt", "csv", "html", "json"];

export function canExportFormat(features: SubscriptionFeatures | undefined, formatKey: ExportFeatureKey): boolean {
    if (!features?.export) return false;
  if (PREMIUM_OVERRIDES.includes(formatKey) && features.export.premium) return true;
  return features.export[formatKey] !== false;
}

export function canUseChat(features: SubscriptionFeatures | undefined): boolean {
  if (!features?.prompt) return false;
  return features.prompt.folderChat === true;
}

// Active-subscription check is intentionally NOT here — the call site reads
// subscription status alongside this feature flag.
export function canImportCSV(features: SubscriptionFeatures | undefined): boolean {
  return features?.import?.csv === true;
}
